const initSnsWindow = () => {
  const shareButton = document.querySelectorAll(".sns-share__btn");
  for (let i = 0; i < shareButton.length; i += 1) {
    shareButton[i].addEventListener(
      "click",
      function (e) {
        e.preventDefault();
        window.open(
          this.href,
          "SNS_window",
          "width=600, height=500, menubar=no, toolbar=no, scrollbars=yes"
        );
      },
      false
    );
  }
};

export default initSnsWindow;
